import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Form,
  Button,
} from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";

interface VendorCostMap {
  [key: string]: number;
}

const Dashboard = () => {
  const [vendor, setVendor] = useState("All");
  const [fromDate, setFromDate] = useState("2025-07-01");
  const [toDate, setToDate] = useState("2025-07-11");
  const [searchAWB, setSearchAWB] = useState("");

  const [trackingLogs, setTrackingLogs] = useState([
    {
      date: "2025-07-10",
      vendor: "Delhivery",
      awb: "123456",
      status: "Delivered",
      response: "OK",
      cost: 1.25,
    },
    {
      date: "2025-07-10",
      vendor: "BlueDart",
      awb: "123457",
      status: "In Transit",
      response: "Pending",
      cost: 1.25,
    },
  ]);

  const filteredLogs = trackingLogs.filter(
    (log) =>
      (vendor === "All" || log.vendor === vendor) &&
      log.awb.includes(searchAWB) &&
      log.date >= fromDate &&
      log.date <= toDate,
  );

  const totalCalls = filteredLogs.length;
  const totalCost = filteredLogs.reduce((sum, log) => sum + log.cost, 0);
  const deliveredCount = filteredLogs.filter(
    (log) => log.status === "Delivered",
  ).length;
  const inTransitCount = filteredLogs.filter(
    (log) => log.status === "In Transit",
  ).length;

  const vendorWiseCost = trackingLogs.reduce((acc: VendorCostMap, curr) => {
    acc[curr.vendor] = (acc[curr.vendor] || 0) + curr.cost;
    return acc;
  }, {} as VendorCostMap);

  const chartData = {
    labels: Object.keys(vendorWiseCost),
    datasets: [
      {
        label: "API Cost per Vendor",
        data: Object.values(vendorWiseCost),
        backgroundColor: "rgba(75,192,192,0.6)",
      },
    ],
  };

  return (
    <Container className="mt-4">
      <h4 className="mb-4">Shipment Tracking Dashboard</h4>
      <Form className="mb-4">
        <Row className="g-2">
          <Col md={3}>
            <Form.Select
              value={vendor}
              onChange={(e) => setVendor(e.target.value)}
            >
              <option value="All">All Vendors</option>
              <option value="Delhivery">Delhivery</option>
              <option value="BlueDart">BlueDart</option>
            </Form.Select>
          </Col>
          <Col md={2}>
            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Col>
          <Col md={2}>
            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Col>
          <Col md={3}>
            <Form.Control
              placeholder="Search AWB No"
              value={searchAWB}
              onChange={(e) => setSearchAWB(e.target.value)}
            />
          </Col>
          <Col md={2}>
            <Button variant="primary" className="w-100">
              Search
            </Button>
          </Col>
        </Row>
      </Form>

      <Row className="mb-4">
        <Col md={3}>
          <Card body className="text-center bg-light shadow">
            <h6>Total API Calls</h6>
            <h4>{totalCalls}</h4>
          </Card>
        </Col>
        <Col md={3}>
          <Card body className="text-center bg-light shadow">
            <h6>Total Cost</h6>
            <h4>₹{totalCost.toFixed(2)}</h4>
          </Card>
        </Col>
        <Col md={3}>
          <Card body className="text-center bg-light shadow">
            <h6>Delivered</h6>
            <h4>{deliveredCount}</h4>
          </Card>
        </Col>
        <Col md={3}>
          <Card body className="text-center bg-light shadow">
            <h6>In Transit</h6>
            <h4>{inTransitCount}</h4>
          </Card>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col md={12}>
          <Bar data={chartData} />
        </Col>
      </Row>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Date</th>
            <th>Vendor</th>
            <th>AWB No</th>
            <th>Status</th>
            <th>Response</th>
            <th>API Cost (₹)</th>
          </tr>
        </thead>
        <tbody>
          {filteredLogs.map((log, index) => (
            <tr key={index}>
              <td>{log.date}</td>
              <td>{log.vendor}</td>
              <td>{log.awb}</td>
              <td>{log.status}</td>
              <td>{log.response}</td>
              <td>{log.cost.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default Dashboard;
